module.exports = __webpack_public_path__ + "media/img/pages/companies/fachhochschulesu_dschweiz-882975527f29f60ce48e69085ddf8e1c.png";